// @TODO: Notifications
// @TODO: Is submitting state

import { useCallback } from "react";
import styled from "@emotion/styled";
import { Form, Formik } from "formik";
import PropTypes from "prop-types";

import { useDrawerState } from "@hmn/coolinarika-web-core/context/Drawer";

import { Button, buttonSizes, buttonVariants } from "../../../../Button";
import { DrawerBody, DrawerFooter } from "../../../../Drawer";
import { withErrorBoundary } from "../../../../ErrorBoundary";
import { DynamicForm, getFormInitialValues, getFormValidation } from "../../../../Form";
import { CheckMarkIcon, Icon } from "../../../../Icon";
// import { Notice, noticeSeverity } from '../../../../Notice'
// Inputs data
import { inputs } from "./inputs";
import styles from "./Other.style";

const SettingsOtherStyled = styled.div((props) => ({ ...styles(props) }));

const SettingsOther = ({ className, ...rest }) => {
    const { contentId: userId } = useDrawerState();

    // Form submit
    const onSubmit = useCallback((values) => {
        // @TODO: Not implemented
    }, []);

    if (!userId) {
        return null;
    }

    return (
        <SettingsOtherStyled className={className} {...rest}>
            <Formik
                initialValues={getFormInitialValues(inputs)}
                validationSchema={getFormValidation(inputs)}
                onSubmit={onSubmit}
            >
                {({ isSubmitting }) => (
                    <Form noValidate>
                        <DrawerBody>
                            <DynamicForm fields={inputs} />
                        </DrawerBody>
                        <DrawerFooter>
                            <Button
                                type="submit"
                                title="Spremi"
                                variant={buttonVariants.QUATERNARY}
                                size={buttonSizes.LARGE}
                                sizeMobile={buttonSizes.NORMAL}
                                width="100%"
                                // disabled={isSubmitting}
                                iconLeftComponent={<Icon icon={CheckMarkIcon} />}
                            >
                                Spremi
                            </Button>
                            {/* @TODO: Notice (remove submit button -> display notice for a few seconds -> remove notice -> display button)
                                        <Notice severity={noticeSeverity.SUCCESS} message="Postavke uspješno spremljene" />
                                    */}
                        </DrawerFooter>
                    </Form>
                )}
            </Formik>
        </SettingsOtherStyled>
    );
};

SettingsOther.propTypes = {
    className: PropTypes.string,
};

SettingsOther.defaultProps = {
    className: undefined,
};

export default withErrorBoundary(SettingsOther);
